import React, { PureComponent } from 'react';
import './CheckoutFooter.scss';

const PAYPAL_POPUP_LINK = 'https://www.paypal.com/uk/webapps/mpp/paypal-popup';

export class CheckoutFooter extends PureComponent {

    handleOpenPaypal = (ev: React.MouseEvent<HTMLElement>) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.nativeEvent.stopImmediatePropagation();

        window.open(
            PAYPAL_POPUP_LINK,
            'WIPaypal',
            'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'
        );

        return false;
    };

    render(): JSX.Element {
        let currentYear = (new Date()).getFullYear();

        return (
            <div className='checkout-footer'>
                <div className='checkout-footer__details'>
                    <div className='checkout-footer__security'>
                        <div className='checkout-footer__security-icon'><i className='sa sa-lock'></i></div>
                        <div className='checkout-footer__security-text'>
                            This page is secure and all of your personal details are safe.
                        </div>
                    </div>
                    <div className='checkout-footer__payment'>
                        <div className='checkout-footer__payment-text'>
                            We accept
                        </div>
                        <div className='checkout-footer__payment-cards'>
                            <div className='checkout-footer__payment-card checkout-footer__payment-card--visa'>Visa</div>
                            <div className='checkout-footer__payment-card checkout-footer__payment-card--maestro'>Maestro</div>
                            <div className='checkout-footer__payment-card checkout-footer__payment-card--masterCard'>MasterCard</div>
                            <div className='checkout-footer__payment-card checkout-footer__payment-card--american'>Amex</div>
                            <div className='checkout-footer__payment-card checkout-footer__payment-card--paypal'>
                                <a
                                    href={PAYPAL_POPUP_LINK}
                                    title='How PayPal Works'
                                    onClick={this.handleOpenPaypal}
                                >
                                    <img
                                        src='https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png'
                                        alt='PayPal Logo' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className='checkout-footer__copyright'>
                    <p>© {currentYear} Sofology Limited. All rights reserved. Registered office: Golborne Point, Ashton Road, Golborne, WA3 3UL. Company registration number: 1778734. Delivery estimates are subject to availability in the location of our customers.</p>
                    <p>Sofology is registered as an agent for finance with the FCA and is compliant with their standards. Finance applications may be proposed to more than one&nbsp;lender.</p>
                </div>
            </div>
        );
    }
}